module.exports = "<tsu-header></tsu-header>\n<div class=\"main-content spacing-20\">\n<router-outlet></router-outlet>\n</div>\n<tsu-footer></tsu-footer>"